import { render } from "./Question.vue?vue&type=template&id=4a9ace46&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=4a9ace46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a9ace46"

export default script